module.exports = __webpack_public_path__ + "img/img_nav_lang.99722e01.svg";